<template>
  <div class="page-container">
    <app-navbar-unauth v-if="displayTopNav"
      class="app-layout__navbar"
      :is-top-bar.sync="isTopBar"
      :minimized.sync="minimized"
    />
    <div class="page-content">
      <slot></slot>
    </div>
    <page-footer />
  </div>
</template>

<script>
import AppNavbarUnauth from '../admin/app-navbar/AppNavbarUnauth'
import PageFooter from '../footer/PageFooter'

export default {
  name: 'publicPage',
  components: {
    AppNavbarUnauth,
    PageFooter,
  },
  props: ['hideTopNav'],
  data () {
    return {
      isTopBar: false,
      minimized: false,
      mobileWidth: 767,
      displayTopNav: !this.hideTopNav,
    }
  },
}
</script>

<style lang="scss">
  .page-content {
    margin: 5rem 1rem 7rem;

    .va-card {
      margin-bottom: 24px;

      &__body {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 1.2rem;
      }

      &__header-title {
        font-size: 1.4rem;
      }
    }
  }

  @include media-breakpoint-up(lg) {
    .page-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 6rem 15% 8rem 15%;

      .va-card {
        width: 100%;

        &__body {
          margin-right: 10%;
          margin-left: 10%;
        }
      }
    }
  }
</style>
